import React from 'react';
import api from "./../../../services/api";
//import { NavLink } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import './../../../pages/Representante_Instituição/Tela_RI_Pacientes_Cadastro/styles.css';
import GetAgent from './GetAgent';
import { user_token } from '../../../services/Auth';
import "./style.css";
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav';
import GetUser from './GetUser';
import GetProfessional from './GetProfessional';

//import da API
import { organizer } from './../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem(user_token);

export default class FormsAgendamento extends React.Component {

  state = {
    exames: [],

  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    const { id } = this.props.match.params;
    console.log(id);
    //const request = await api.get(`/exam/${id}`, { headers: { 'x-access-token': token } });
    const request = await apiOrganizer.getExam(id);
    //console.log(request);
    console.log("DADOS DO EXAM" + request.data._id);
    this.setState({ exames: request.data });
    const listArray = request.data.possible_date;
    console.log("Esse eh o array: " + listArray);
  };

  render() {

    return (
      <>
        <SideNav />
        <div id="top-Consulta">
          <Grid container spacing={0} direction="row" justify="left" alignItems="center" style={{ marginTop: '-35vh' }}>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">

            </Grid>
            <Grid item xs={8} sm={8} md={10} lg={10}></Grid>
            <Grid item xs={2} sm={2} md={1} lg={1} align="center">
            </Grid>
          </Grid>
        </div>
        <Grid container spacing={0} direction="row" justify="left" alignItems="center">
          <Grid item xs={12} sm={12} md={10} lg={3} align="center"></Grid>
          <Grid item xs={12} sm={12} md={10} lg={6} align="center">
            <div id="main-RI-Consulta-Pendente">
              <h1 id="title">Consulta Realizada</h1>
              <br></br>
              <div id="lista-style">
                {this.state.exames.map(details => (
                  <>
                    <div id="exam">

                      <h1 id="tittle-forms-cme">Informações da Instituição</h1>
                      <hr id="coloring_line" />
                      <GetAgent agent_id={details.agent_id} />
                      <hr id="coloring_line" />
                      <br></br>


                      <h1 id="tittle-forms-cme">Informações do Paciente</h1>
                      <hr id="coloring_line" />
                      <GetUser user_id={details.user_id} />
                      <hr id="coloring_line" />
                      <br></br>
                      <h1 id="tittle-forms-cme">Dados da Consulta</h1>
                      <hr id="coloring_line" />
                      <p id="RI-Title-Cadastro-Paciente">Período da consulta: </p><p>{details.appointment_period}</p>
                      <p id="RI-Title-Cadastro-Paciente">Tipo de Consulta:</p><p>{details.appointment_type}</p>
                      <p id="RI-Title-Cadastro-Paciente">Especialidade Médica: </p><p>{details.medical_appointment_type}</p>
                      <p id="RI-Title-Cadastro-Paciente">Motivo da Consulta: </p><p>{details.appointment_purpose}</p>
                      <p id="RI-Title-Cadastro-Paciente">Obervações:</p><p>{details.notes}</p>
                      <p id="RI-Title-Cadastro-Paciente">Status:</p><p>{details.status}</p>
                      <p id="RI-Title-Cadastro-Paciente">Receita:</p><p>{details.prescription}</p>
                      <p id="RI-Title-Cadastro-Paciente">Notas do(a) Profissional da Saúde:</p><p>{details.medical_note}</p>
                      <p id="RI-Title-Cadastro-Paciente">Data da Consulta:</p><p>{details.appointment_date}</p>
                      <hr id="coloring_line" />
                      <br></br>
                      <div id="maximing-tittle">
                        <h1 id="tittle-forms-cme">Dados do Profissional</h1>
                      </div>
                     
                          <br></br>
                          <GetProfessional professional_id={details.professional_id} />                          
                      <br></br>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}
